<template>
    <button
        :class="[getButtonClass, { _active: active }]"
        @click="toggleFavoriteStatus"
    >
        <span></span>
    </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'FavoriteButton',
    props: {
        id: {
            type: Number,
            default: null,
        },
        isCatalog: {
            type: Boolean,
            default: false,
        },
        isComplex: {
            type: Boolean,
            default: false,
        },
        isPopup: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters('favorites', ['favoritesIds']),
        active () {
            return this.isComplex
                ? this.favoritesIds.complexes.findIndex(id => id === this.id) !== -1
                : this.favoritesIds.properties.findIndex(id => id === this.id) !== -1;
        },
        getButtonClass() {
            if (this.isPopup) {
                return 'actions-images-popup__favorite';
            }
            return this.isCatalog ? 'favorite-card-btn' : 'images-top-object__favorite';
        }
    },
    methods: {
        async toggleFavoriteStatus() {
            const response = await this.$store.dispatch('favorites/store', {id: this.id, isComplex: this.isComplex})
            if(response) console.log(response?.message || 'Error')
        }
    },
}
</script>
